module.exports = __webpack_public_path__ + "static/tony-006-e15826347ae82c92b73d09b7b8d7152a.jpg";